<div class="ui-address-custom">
  <!--
    `floatLabel="always"` for the same reason as ui-single-house-address: this
    field also lives inside `ui-insurables`, where the reskin visually CLIPS
    Material's floating label (it duplicates the `.section-title` above every
    other field there — see the `ui-insurables` block in
    assets/styles/components/pma-flow/index.scss). With the label clipped and not
    floating, MDC holds the placeholder at `opacity: 0`
    (`.mdc-text-field__input::placeholder{opacity:0}`, lifted only by `--focused`
    or `.mat-mdc-form-field-label-always-float`) — so the box read as empty until
    it was clicked. Always-float lifts it; the label stays clipped and keeps
    providing the accessible name.

    This is the `nonpreferred_address_selection` path; single-house mode has its
    own component with the identical fix.
  -->
  <mat-form-field fxFlex="" appearance="outline" floatLabel="always">
    <mat-label>{{ 'residential.address' | translate }}</mat-label>
    <input matInput
           [formControl]="form.controls['address']"
           [matAutocomplete]="autoInsurable"
           placeholder="Start typing your address..."/>

    <div matPrefix style="margin: 8px">
      <mat-icon>home</mat-icon>
    </div>
    <button *ngIf="loadingAddress" class="text-secondary spinner" mat-icon-button matSuffix type="button">
      <mat-icon>loading</mat-icon>
    </button>
    <mat-autocomplete autoActiveFirstOption #autoInsurable="matAutocomplete" (optionSelected)="selectAddress($event.option.value)" [displayWith]="displayFnInsurable">
      <mat-option *ngFor="let address of addresses" [value]="address">
        {{ address.full_str }}
      </mat-option>
    </mat-autocomplete>
    <mat-hint class="mat-hint-address" *ngIf="addresses && addresses.length === 0">
        <ng-container *ngIf="showAddressHint">
            No addresses found, type another address and select it
        </ng-container>
        <ng-container *ngIf="continueEnteringHint">
            <strong style="font-size: 15px">Continue entering your address so we may make a match</strong>
        </ng-container>
    </mat-hint>

    <mat-error *ngIf="form.get('address').hasError('addressNotSelected')">
      Select an address from the dropdown
    </mat-error>
    <mat-error *ngIf="form.get('address').invalid && !form.get('address').hasError('addressNotSelected')">
      {{ form.get('address') | errorMsg:'Address' }}
    </mat-error>
  </mat-form-field>

  <div class="existing-address-hint" *ngIf="existingAddress">
    Did you mean:
    <button mat-button type="button" (click)="selectExistingAddress()">{{ existingAddress.full }}</button>?
  </div>
</div>
